import { useCallback, useState } from 'react';
import { compose } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Modal } from 'foundations-components/transitional/components/Modal';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getHasForecastingEditScope } from '../../selectors/authSelectors';

// @ts-expect-error untyped
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
// @ts-expect-error untyped
import PipelineReferenceResolver from 'reference-resolvers/resolvers/PipelineReferenceResolver';
// @ts-expect-error untyped
import DealPropertyReferenceResolver from 'reference-resolvers/resolvers/DealPropertyReferenceResolver';
// @ts-expect-error untyped
import PipelineStageReferenceResolver from 'reference-resolvers/resolvers/PipelineStageReferenceResolver';
import { DEAL_PIPELINE, DEAL_PROPERTY, DEAL_PIPELINE_STAGE
// @ts-expect-error untyped
} from 'reference-resolvers/constants/ReferenceObjectTypes';
import Wizard from '../wizard/Wizard';
import { trackWizardStart } from '../../utils/usageTracker';
import { SET_PROCESSING_DEALS_STATUS } from '../../actions/ActionTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CategoryForecastingSetup({
  onConfirm
}) {
  const dispatch = useDispatch();
  const hasForecastingEditScope = useSelector(getHasForecastingEditScope);
  const [isWizardOpen, setWizardOpen] = useState(false);
  const handleClick = useCallback(() => {
    setWizardOpen(true);
    trackWizardStart();
  }, []);
  const handleConfirm = useCallback(() => {
    setWizardOpen(false);
    dispatch({
      type: SET_PROCESSING_DEALS_STATUS,
      payload: true
    });
    onConfirm();
  }, [dispatch, onConfirm]);
  const handleReject = useCallback(() => setWizardOpen(false), []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EmptyState, {
      titleText: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup.content.title"
        })
      }),
      primaryContent: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "setup.content.description"
          })
        }), /*#__PURE__*/_jsx(UITooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "setup.content.footer.tooltip"
          }),
          placement: "bottom",
          disabled: hasForecastingEditScope,
          children: /*#__PURE__*/_jsx(Flex, {
            display: "inline-flex",
            children: /*#__PURE__*/_jsx(UIButton, {
              use: "primary",
              onClick: handleClick,
              disabled: !hasForecastingEditScope,
              "data-test-id": "get-started-button",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "setup.content.footer.buttons.primary"
              })
            })
          })
        })]
      }),
      secondaryContent: /*#__PURE__*/_jsx(Illustration, {
        name: "forecasting",
        width: "100%"
      }),
      secondaryContentWidth: 175
    }), isWizardOpen && /*#__PURE__*/_jsx(Modal, {
      use: "fullscreen",
      children: /*#__PURE__*/_jsx(Wizard, {
        onConfirm: handleConfirm,
        onReject: handleReject
      })
    })]
  });
}
export default compose(ProvideReferenceResolvers({
  [DEAL_PIPELINE]: PipelineReferenceResolver,
  [DEAL_PROPERTY]: DealPropertyReferenceResolver,
  [DEAL_PIPELINE_STAGE]: PipelineStageReferenceResolver
}))(CategoryForecastingSetup);